import { get, put } from 'utils/api';
import { createAsyncThunk } from '@reduxjs/toolkit';

import TYPES from './types';

export const getReportsVisibility = createAsyncThunk(
  TYPES.GET_REPORTS_VISIBILITY,
  async (params, { rejectWithValue }) => {
    try {
      const { id } = params;

      const res = await get(`/report-types/${id}/visibility`);

      return res?.data;
    } catch (e) {
      return rejectWithValue(e);
    }
  }
);

export const updateReportsVisibility = createAsyncThunk(
  TYPES.UPDATE_REPORTS_VISIBILITY,
  async (params, { rejectWithValue }) => {
    try {
      const { id, ...rest } = params;
      const res = await put(`/report-types/${id}/visibility`, { ...rest });

      return res?.data;
    } catch (e) {
      return rejectWithValue(e);
    }
  }
);
